import React, { FC, ReactElement } from 'react'
import { Chart, ChartProps } from 'react-chartjs-2'

export type LineGraphProps = Omit<ChartProps<'line' | 'bar', unknown[]>, 'type'>

const LineGraph: FC<LineGraphProps> = (props): ReactElement => {
  return <Chart type='line' {...props} />
}
export default LineGraph
